module.exports = __webpack_public_path__ + "img/h5.baf680dd.png";